module.exports = __webpack_public_path__ + "img/18_36.a3af4f0f.png";